export default __webpack_public_path__ + "static/media/userjourney4.88b73250.png";